import React from "react";
import SmartImage from "../SmartImage";
import {
  BackIcon,
  EachBlog,
  EachPopularCourse,
  PopularCourseContent,
} from "./style";
import {
  BoldHeadingPri,
  BoldLg,
  BoldSm,
  HorizontalAlign,
  HorizontalLeftAlign,
  RegLg,
  RegSm,
  RegSmPri,
  SpaceBetween,
  VerticalLeftAlign,
  VerticalSpaceBetween,
} from "../CustomStyles";
import Colors from "../../Constant/Colors";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import images from "../../Constant/images";
import dayjs from "dayjs";

const NewsDetails = ({ handleBack, blog, handleDownloadNews, isNewsPage }) => {
  const handleDownload = () => {
    handleDownloadNews(blog);
    handleBack();
  };
  const styles = {
    img: {
      width: "90%",
      height: 380,
      alignSelf: "center",
      objectFit: "cover",
      borderRadius: 8
    },
  }
  return (
    <PopularCourseContent>
      <HorizontalLeftAlign style={{ marginTop: 10, marginBottom: 10 }}>
        <BackIcon onClick={handleBack}>
          <KeyboardBackspaceIcon style={{ marginBottom: -6 }} />
        </BackIcon>
        <BoldHeadingPri>{"News Details"}</BoldHeadingPri>
      </HorizontalLeftAlign>
      <EachPopularCourse>
        <SmartImage
          src={blog?.image ? blog?.image : images?.res1}
          style={styles.img}
        />
        <EachBlog>
          <VerticalSpaceBetween>
            <VerticalLeftAlign>
              <BoldLg style={{ marginTop: 10, marginBottom: 10 }}>
                {blog?.title}
              </BoldLg>
              <RegLg style={{ color: Colors.lightTxt }}>
                {blog?.description}
              </RegLg>
            </VerticalLeftAlign>
            <SpaceBetween style={{ marginTop: 10 }}>
              <HorizontalAlign>
                <RegSm>{"Admin "}</RegSm>
                <RegSmPri style={{ color: Colors.lightTxt }}>
                  - {dayjs(blog?.created_at).format("DD MMM YYYY")}
                </RegSmPri>
              </HorizontalAlign>
              {isNewsPage && (
                <BoldSm onClick={handleDownload} style={{ cursor: "pointer" }}>
                  Download Now
                </BoldSm>
              )}
            </SpaceBetween>
          </VerticalSpaceBetween>
        </EachBlog>
      </EachPopularCourse>
    </PopularCourseContent>
  );
};

export default NewsDetails;
